var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.662,
    height: 10.545,
    viewBox: "0 0 5.662 10.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M.419,5.626A.657.657,0,0,1,.085,4.7C.2,4.509,4.448.275,4.625.173A1.285,1.285,0,0,1,6.039.256c.254.192,4.385,4.342,4.453,4.475a.737.737,0,0,1,.053.282.635.635,0,0,1-.579.641c-.331.028-.223.121-2.55-2.2L5.275,1.312,3.146,3.438C1.66,4.923.985,5.579.9,5.614A.816.816,0,0,1,.419,5.626Z",
    transform: "translate(5.662) rotate(90)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIndicator);
export default __webpack_public_path__ + "static/media/RightIndicator.ce52eef4e5631f9dfd3e267b2b4f43d5.svg";
export { ForwardRef as ReactComponent };